// extracted by mini-css-extract-plugin
export var bodyRow = "_da-d";
export var cardColumns = "_da-e";
export var ellipsesOverflow = "_da-2";
export var flatBottomCorners = "_da-3";
export var flatTopCorners = "_da-4";
export var headerActionsDropdown = "_da-f";
export var headerBottomRow = "_da-c";
export var headerTopRow = "_da-b";
export var orderDetailsWrapper = "_da-0";
export var orderInfoContainer = "_da-1";
export var productDetails = "_da-9";
export var productImage = "_da-5";
export var responsiveTable = "_da-8";
export var shipmentContainer = "_da-a";
export var tableBottomLeft = "_da-6";
export var tableBottomRight = "_da-7";
export var trackingLink = "_da-g";